import logger from 'utils/logger-aws'
import { EventAPIResponse } from '../types'
import { generateEventEngineBasePath } from 'utils'

export class EventService {
  getEventsFromEventEngine = async (
    startDate: string,
    endDate: string,
    artistId: string | undefined
  ): Promise<{ formattedEvents: EventAPIResponse[]; activeMonthList: string[] }> => {
    if (!artistId) {
      logger.error(`[EventService] - ArtistId is empty`)
    }

    try {
      const eventEngineAPIRequestUrl = `${generateEventEngineBasePath()}&artist_id=${artistId}&start_date=${startDate}&end_date=${endDate}`
      const response = await fetch(eventEngineAPIRequestUrl, {
        headers: {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_EVENT_ENGINE_AUTH_TOKEN}`
        }
      })

      if (!response.ok) {
        logger.error(`[EventService] - ${response.statusText}`)
        return { formattedEvents: [], activeMonthList: [] }
      }

      const { results, meta } = await response.json()
      return { formattedEvents: Object.values(results), activeMonthList: meta?.activeMonthList }
    } catch (error) {
      logger.error('Failed to fetch events:', error)
      return { formattedEvents: [], activeMonthList: [] }
    }
  }
}
